var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0117 11.255H12.2217L11.9417 10.985C12.9217 9.845 13.5117 8.365 13.5117 6.755C13.5117 3.165 10.6017 0.255005 7.01172 0.255005C3.42172 0.255005 0.511719 3.165 0.511719 6.755C0.511719 10.345 3.42172 13.255 7.01172 13.255C8.62172 13.255 10.1017 12.665 11.2417 11.685L11.5117 11.965V12.755L16.5117 17.745L18.0017 16.255L13.0117 11.255ZM7.01172 11.255C4.52172 11.255 2.51172 9.245 2.51172 6.755C2.51172 4.26501 4.52172 2.255 7.01172 2.255C9.50172 2.255 11.5117 4.26501 11.5117 6.755C11.5117 9.245 9.50172 11.255 7.01172 11.255Z",
    fill: "#BFB9D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.6396c882f1449887a9cc7caf0142ff76.svg";
export { ForwardRef as ReactComponent };